import LoginUtils from '@/core/util/login-utils'
import EmpresaUtils from '@/core/util/empresa-utils'
import { TipoPerfilUtil } from '@/core/types/tipo-perfil'

export const Authorization = {

  authorize: (requiresLogin, permissions, requiresCompany) => {
    if (requiresLogin && !LoginUtils.isUsuarioLogado()) {
      return 'login-required'
    }

    if (requiresCompany && !EmpresaUtils.isEmpresaEscolhida()) {
      return 'company-required'
    }

    if (requiresLogin && !permissions) {
      return 'authorized'
    }

    if (permissions && permissions.length) {
      const usuario = LoginUtils.getUsuario()

      return permissions.includes(TipoPerfilUtil.obterPorId(usuario.perfil_id)) ? 'authorized' : 'unauthorized'
    }

    return 'authorized'
  }

}

export default Authorization
